module.exports = __webpack_public_path__ + "static/media/22ESCWA8.e785dd50.jpg";